import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import ClientProfilePictureLoader from "@/app/(main)/_club_components/client-profile-picture-loader";
import ProfilePicture from "@/components/user/profile-picture";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import useMobile from "@/hooks/use-mobile";
import { clubFormats } from "@/lib/club-constants";
import { Club } from "@/TS/Interfaces/global_interfaces";
import { getIconBySlug } from "@/utils/icon-mapping";
interface ClubCardProps {
  club: Club;
  className?: string;
}

// Composant pour afficher une carte de club
export default function ClubCard(t0) {
  const $ = _c(62);
  const {
    club,
    className
  } = t0;
  const clubFormatArray = clubFormats[club.format as keyof typeof clubFormats];
  const isMobile = useMobile();
  let t1;
  if ($[0] !== club.theme) {
    t1 = club.theme?.icon?.slug ? getIconBySlug(club.theme.icon.slug) : null;
    $[0] = club.theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ThemeIcon = t1;
  const t2 = `w-[330px] pt-3 pb-8  relative ${className} ${isMobile ? "" : "pr-3"}`;
  let t3;
  if ($[2] !== t2) {
    t3 = twMerge(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = "/club/" + club.slug as Route;
  let t5;
  if ($[4] !== club.new) {
    t5 = club.new == true && <div className="relative -right-[28%] text-white text-sm"><div className="bg-info-blue p-2 font-sora">NOUVEAU</div><div className="new-label-triangles rounded-b-sm"><div /></div></div>;
    $[4] = club.new;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== club.displayName) {
    t6 = <h3 className="text-2xl font-bold line-clamp-3">{club.displayName}</h3>;
    $[6] = club.displayName;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `rounded-full py-1 px-4 text-white ${clubFormatArray?.bgColor} flex items-center mr-3`;
  const t8 = clubFormatArray?.label;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = club.countActiveMembers > 1 ? "s" : "";
  let t11;
  if ($[11] !== club.countActiveMembers || $[12] !== t10) {
    t11 = <div className="rounded-full py-1 px-4 flex-col justify-center items-center text-white bg-member-blue">{club.countActiveMembers} membre{t10}</div>;
    $[11] = club.countActiveMembers;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t9) {
    t12 = <div className="flex justify-center">{t9}{t11}</div>;
    $[14] = t11;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== ThemeIcon || $[18] !== club.theme) {
    t13 = club.theme && <div className="rounded-full m-3 py-1 px-4 flex items-center text-black bg-yellow">{ThemeIcon && <ThemeIcon className="mr-2" style={{
        fontSize: "20px"
      }} />}{club.theme.name}</div>;
    $[17] = ThemeIcon;
    $[18] = club.theme;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <div className="flex flex-wrap justify-center">{t13}</div>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12 || $[23] !== t14 || $[24] !== t6) {
    t15 = <div className="flex flex-col justify-center font-bold px-4 text-center h-[220px] w-full">{t6}{t12}{t14}</div>;
    $[22] = t12;
    $[23] = t14;
    $[24] = t6;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ClientProfilePictureLoader key="samekey" size={72} />;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const t17 = club?.president?.avatar?.urls?.avatar_md;
  const t18 = club?.president?.firstName;
  const t19 = club?.president?.lastName;
  const t20 = `${club?.president?.firstName || ""} ${club?.president?.lastName || ""}`;
  let t21;
  if ($[27] !== t17 || $[28] !== t18 || $[29] !== t19 || $[30] !== t20) {
    t21 = <div className="flex items-center shrink-0">{t16}<ProfilePicture suppressHydrationWarning={true} key="paslasamekey" src={t17} firstName={t18} lastName={t19} className="-mt-2 mr-2" size={72} alt={t20} /></div>;
    $[27] = t17;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="mt-2">Présidé par</p>;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  const t23 = club?.president?.firstName;
  const t24 = club?.president?.lastName;
  let t25;
  if ($[33] !== t24) {
    t25 = <span className="uppercase">{t24}</span>;
    $[33] = t24;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  if ($[35] !== t23 || $[36] !== t25) {
    t26 = <TooltipTrigger asChild={true}><p className="font-bold mb-2.5 truncate">{t23}{" "}{t25}</p></TooltipTrigger>;
    $[35] = t23;
    $[36] = t25;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  const t27 = club?.president?.firstName;
  const t28 = club?.president?.lastName;
  let t29;
  if ($[38] !== t28) {
    t29 = <span className="uppercase">{t28}</span>;
    $[38] = t28;
    $[39] = t29;
  } else {
    t29 = $[39];
  }
  let t30;
  if ($[40] !== t27 || $[41] !== t29) {
    t30 = <TooltipContent>{t27}{" "}{t29}</TooltipContent>;
    $[40] = t27;
    $[41] = t29;
    $[42] = t30;
  } else {
    t30 = $[42];
  }
  let t31;
  if ($[43] !== t26 || $[44] !== t30) {
    t31 = <div className="text-center flex flex-col justify-between min-w-0 flex-1 ml-3"><div className="min-w-0">{t22}<Tooltip>{t26}{t30}</Tooltip></div></div>;
    $[43] = t26;
    $[44] = t30;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== t21 || $[47] !== t31) {
    t32 = <div className="flex flex-row items-center w-full px-5 bg-white grow align-middle h-[100px] rounded-b-[20px]">{t21}{t31}</div>;
    $[46] = t21;
    $[47] = t31;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  let t33;
  if ($[49] !== club.distance) {
    t33 = club.distance >= 0 && <div className="flex flex-row items-center w-full  bg-white grow justify-center align-middle h-[50px] rounded-b-[20px]"><div className="flex items-center text-dark-grey text-[1em]"><LocationOnIcon /><span>{(club.distance ?? "") + "km"} </span></div></div>;
    $[49] = club.distance;
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  let t34;
  if ($[51] !== t15 || $[52] !== t32 || $[53] !== t33 || $[54] !== t5) {
    t34 = <div className="flex flex-col items-center relative rounded-[20px] shadow-[0_0_5px_rgba(0,0,0,0.2)] h-[350px] bg-info cursor-pointer transition-all duration-300 ease-in-out hover:shadow-[0_4px_15px_rgba(0,0,0,0.2)] hover:scale-[1.01]">{t5}{t15}{t32}{t33}</div>;
    $[51] = t15;
    $[52] = t32;
    $[53] = t33;
    $[54] = t5;
    $[55] = t34;
  } else {
    t34 = $[55];
  }
  let t35;
  if ($[56] !== t34 || $[57] !== t4) {
    t35 = <Link href={t4}>{t34}</Link>;
    $[56] = t34;
    $[57] = t4;
    $[58] = t35;
  } else {
    t35 = $[58];
  }
  let t36;
  if ($[59] !== t3 || $[60] !== t35) {
    t36 = <div className={t3}>{t35}</div>;
    $[59] = t3;
    $[60] = t35;
    $[61] = t36;
  } else {
    t36 = $[61];
  }
  return t36;
}